var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleMinus = function SvgCircleMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.16 10.292V8.708h9.59v1.584H5.16zm4.795 7.125c4.407 0 7.992-3.551 7.992-7.917 0-4.365-3.585-7.917-7.992-7.917S1.962 5.135 1.962 9.5c0 4.366 3.586 7.917 7.993 7.917zM9.955 0c5.288 0 9.59 4.262 9.59 9.5S15.243 19 9.955 19C4.666 19 .364 14.738.364 9.5S4.666 0 9.954 0z"
  })));
};

export default SvgCircleMinus;